// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1529":"aa96c6a0","1698":"d925b8ec","2111":"d925b8ec","5620":"aa96c6a0","7040":"73d13f8e"}[chunkId] + ".chunk.css";
};